var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1735902013930,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5495,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.9 748.78h97.86V776a8 8 0 0 1-8 8h-81.86a8 8 0 0 1-8-8v-27.2-0.02z",
    fill: "#495057",
    "p-id": 5496
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M621.26 748.78h97.86V776a8 8 0 0 1-8 8h-81.86a8 8 0 0 1-8-8v-27.2-0.02z",
    fill: "#15AABF",
    "p-id": 5497
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114 236.04m100.04 0l531.92 0q100.04 0 100.04 100.04l0 328.28q0 100.04-100.04 100.04l-531.92 0q-100.04 0-100.04-100.04l0-328.28q0-100.04 100.04-100.04Z",
    fill: "#ADB5BD",
    "p-id": 5498
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M594 324a20 20 0 0 1-19.58-16L564 256.2a40.12 40.12 0 0 0-39.18-32.2h-89.64A40.12 40.12 0 0 0 396 256.2l-10.38 51.8a20 20 0 1 1-39.22-7.86l10.36-51.8A80.22 80.22 0 0 1 435.18 184h89.62a80.22 80.22 0 0 1 78.44 64.36l10.36 51.8A20 20 0 0 1 594 324z",
    fill: "#495057",
    "p-id": 5499
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 214L197.2 440.5a100 100 0 0 0 91.52 59.72h384.32a100 100 0 0 0 91.64-60L862.5 216z",
    fill: "#868E96",
    "p-id": 5500
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M305.76 453.52m23.8 0l18.4 0q23.8 0 23.8 23.8l0 45.8q0 23.8-23.8 23.8l-18.4 0q-23.8 0-23.8-23.8l0-45.8q0-23.8 23.8-23.8Z",
    fill: "#495057",
    "p-id": 5501
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M588.26 453.52m23.8 0l18.4 0q23.8 0 23.8 23.8l0 45.8q0 23.8-23.8 23.8l-18.4 0q-23.8 0-23.8-23.8l0-45.8q0-23.8 23.8-23.8Z",
    fill: "#495057",
    "p-id": 5502
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M716 692m-198 0a198 198 0 1 0 396 0 198 198 0 1 0-396 0Z",
    fill: "#FCC419",
    "p-id": 5503
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M716 692m-162 0a162 162 0 1 0 324 0 162 162 0 1 0-324 0Z",
    fill: "#FFD43B",
    "p-id": 5504
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M652.64 729.48a47.64 47.64 0 1 1 47.64-47.64 47.7 47.7 0 0 1-47.64 47.64z m0-83.28a35.64 35.64 0 1 0 35.64 35.64 35.68 35.68 0 0 0-35.64-35.64zM779.36 729.48a47.64 47.64 0 1 1 47.64-47.64 47.7 47.7 0 0 1-47.64 47.64z m0-83.28a35.64 35.64 0 1 0 35.64 35.64 35.68 35.68 0 0 0-35.64-35.64z",
    fill: "#495057",
    "p-id": 5505
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M736 679.12c-22.82-10.26-38.78-0.78-39.44-0.38l-6.36-10.18c0.88-0.56 21.8-13.38 50.72-0.4zM716 795.76a47.74 47.74 0 0 1-41.66-24.5 6 6 0 1 1 10.48-5.84 35.68 35.68 0 0 0 62.36 0 6 6 0 0 1 10.48 5.84A47.74 47.74 0 0 1 716 795.76z",
    fill: "#495057",
    "p-id": 5506
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M654.5 689.5m-13.5 0a13.5 13.5 0 1 0 27 0 13.5 13.5 0 1 0-27 0Z",
    fill: "#495057",
    "p-id": 5507
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M777.5 689.5m-13.5 0a13.5 13.5 0 1 0 27 0 13.5 13.5 0 1 0-27 0Z",
    fill: "#495057",
    "p-id": 5508
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.756ad6db4228fb443fc5cdf62a427570.svg";
export { ForwardRef as ReactComponent };